import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef } from 'react';

import { Box } from '@mui/material';

import useAuth from '../hooks/useAuth';
import useBranding from '../hooks/useBranding';

const Page = forwardRef(({ children, title = '', meta, ...other }, ref) => {
  const { isAuthenticated } = useAuth();
  const { name: brandName } = useBranding();
  const name = isAuthenticated ? brandName : '';

  return (
    <>
      <Helmet>
        <title>{name ? `${title} | ${name}` : title}</title>
        {meta}
      </Helmet>

      <Box ref={ref} {...other}>
        {children}
      </Box>
    </>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
};

export default Page;
